import Vue from 'vue'
import VueRouter from 'vue-router'
import Home from '@/views/Home.vue'
Vue.use(VueRouter)
const routes = [
  {
    path: '/',
    name: 'Home',
    component: Home
  },
  {
    path: '/login',
    name: 'Login',
    component: () => import("@/views/Login.vue")
  },
  {
    path: '/register',
    name: 'Register',
    component: () => import("@/views/Register.vue")
  },
  {
    path: '/systemHome',
    name: 'SystemHome',
    redirect: "/SystemHome/projectInfo",
    component: () => import("@/views/SystemHome.vue"),
    children: [
      {
        path: 'projectInfo',
        name: 'projectInfo',
        component: () => import("@/views/ListPage.vue"),
        meta: { moduleId: '1',name: '项目信息' }
      },
      {
        path: 'myProject',
        name: 'myProject',
        component: () => import("@/views/ListPage.vue"),
        meta: { moduleId: '2',name: '我的项目' }
      },
      {
        path: 'apply',
        name: 'apply',
        component: () => import("@/views/PartIn.vue"),
        meta: { moduleId: '1',name: '项目申请' }
      },
      {
        path: 'tender',
        name: 'tender',
        component: () => import("@/views/PartIn.vue"),
        meta: { moduleId: '2',name: '项目投标' }
      }
    ]
  }
]
const router = new VueRouter({
  routes
})
export default router
